<template>
  <div class="certification-page">
    <section class="hero" v-if="banners && banners.length">
      <el-carousel :interval="5000" arrow="hover" height="360px" indicator-position="outside">
        <el-carousel-item v-for="(b,i) in banners" :key="i">
          <div :style="getBannerStyle(b)" class="carousel-slide" @click="openAd(b)">
            <div class="overlay">
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- Certificate Query Section -->
    <section class="section-block query-section">
        <div class="hr-header">
          <div class="hr-title-row">
            <div class="hr-title-main">
              <img src="@/assets/image/i_tt.png" alt="" class="hr-icon">
              <span>证书查询</span>
            </div>
          </div>
          <div class="hr-subtitle">只为核心推荐 为您的英才计划保驾护航 没有最好 只有更好</div>
        </div>
        
        <div class="query-container">
          <div class="query-left">
            <div class="query-header">
              <h3 class="query-title">考试资讯</h3>
              <router-link v-if="announcements.length > 0" to="/news?category=exam_news" class="query-more">更多>></router-link>
            </div>
            <ul class="query-list" v-loading="newsLoading">
              <li v-for="(item, index) in announcements" :key="index" @click="goToNewsDetail(item)">
                <span class="query-dot"></span>
                <span class="query-text" :title="item.title">{{ item.title }}</span>
                <span class="query-date">{{ item.date }}</span>
              </li>
            </ul>
            <div class="query-tips">
              <div class="tips-title">【友情提示】</div>
              <div class="tips-content">
                <p>1. 查询证书需经权属人同意</p>
                <p>2. 证书查询结果不得用于商业入驻之用途</p>
                <p>3. 监督电话：010-999999999</p>
              </div>
            </div>
          </div>
          
          <div class="query-right">
            <div class="form-card">
              <div class="form-header">职业技能等级证书</div>
              <el-form :model="queryForm" class="custom-query-form" label-position="left" label-width="80px">
                <el-form-item label="学员姓名">
                  <el-input v-model="queryForm.name" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="证件号码">
                  <el-input v-model="queryForm.idCard" placeholder="请输入身份证号（与准考证号二选一）"></el-input>
                </el-form-item>
                <el-form-item label="准考证号">
                  <el-input v-model="queryForm.certNo" placeholder="请输入准考证号（与证件号码二选一）"></el-input>
                </el-form-item>
                <el-button type="primary" class="query-submit-btn" @click="handleQuery">查询</el-button>
              </el-form>
              <div class="form-footer">
                <div class="footer-label">查询说明：</div>
                <div class="footer-text">
                  请输入学员姓名和证件号码，或学员姓名和准考证号进行查询。<br>
                  证件号码与准考证号填写其中一项即可。<br>
                  如果查询结果没有公布，请耐心等待或联系客服。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Certification Categories Section -->
      <section class="section-block categories-section">
        <div class="hr-header white-text">
          <div class="hr-title-row">
            <div class="hr-title-main">
              <img src="@/assets/new_picture/i_tt_2.png" alt="" class="hr-icon">
              <span>认证类别</span>
            </div>
          </div>
          <div class="hr-subtitle">只为核心推荐 为您的英才计划保驾护航 没有最好 只有更好</div>
        </div>
        
        <div class="categories-accordion">
          <div 
            v-for="(cat, index) in categories" 
            :key="index"
            class="accordion-item"
            :class="{ active: activeCategory === index }"
            @mouseenter="activeCategory = index"
          >
            <!-- Inactive State: Cover Image & Title -->
            <div class="accordion-cover" :style="{ backgroundImage: `url(${cat.image})` }">
              <div class="cover-overlay"></div>
              <div class="cover-title">{{ cat.title }}</div>
            </div>

            <!-- Active State: Detail Content -->
            <div class="accordion-detail" v-if="activeCategory === index">
              <div class="detail-header">
                <span class="detail-title">{{ cat.title }}</span>
                <span class="detail-subtitle">| 样本</span>
              </div>
              <div class="detail-body">
                <div class="detail-text">
                  <div class="text-scroll">
                    <p>{{ cat.description || '暂无详细介绍' }}</p>
                  </div>
                </div>
                <div class="detail-image">
                  <img :src="cat.image" alt="Certificate Sample">
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Hot Certifications Section -->
      <section class="section-block hot-certs-section">
        <div class="hr-header white-text">
          <div class="hr-title-row">
            <div class="hr-title-main">
              <img src="@/assets/new_picture/i_tt_2.png" alt="" class="hr-icon">
              <span>热门认证</span>
            </div>
          </div>
          <div class="hr-subtitle">只为核心群体 为您的英才计划保驾护航 没有最好 只有更好</div>
        </div>
        
        <div class="hot-cert-card" v-if="hotCerts.length > 0">
          <!-- Custom Tabs Header -->
          <div class="hot-cert-header">
            <div class="timeline-track"></div>
            <div 
              class="cert-tab-item" 
              v-for="(cert, index) in hotCerts" 
              :key="index"
              :class="{ active: Number(activeHotCert) === index }"
              @click="activeHotCert = String(index)"
            >
              <div class="tab-pill">{{ cert.name }}</div>
              <div class="tab-dot"></div>
            </div>
          </div>

          <!-- Content Body -->
          <div class="hot-cert-body">
            <div class="cert-content-item cert-content-left">
              <div class="cert-info-row">
                <span class="cert-unit-label">{{ hotCerts[Number(activeHotCert)].certificationUnit }}</span>
              </div>
            </div>
            <div class="cert-content-item cert-content-center">
              <div class="cert-info-row">
                <span class="cert-project-name">[{{ hotCerts[Number(activeHotCert)].name }}]</span>
              </div>
              <div class="cert-desc-row" v-if="hotCerts[Number(activeHotCert)].description">
                <span class="cert-desc-text" v-html="hotCerts[Number(activeHotCert)].description"></span>
              </div>
            </div>
            <div class="cert-content-item cert-content-right">
              <div class="cert-image-wrapper" v-if="hotCerts[Number(activeHotCert)].image && !hotCerts[Number(activeHotCert)].imageLoadError">
                <el-image 
                  :src="hotCerts[Number(activeHotCert)].image" 
                  :preview-src-list="[hotCerts[Number(activeHotCert)].image]"
                  @error="handleImageError(Number(activeHotCert))"
                  fit="contain"
                  class="preview-image"
                >
                </el-image>
              </div>
            </div>
          </div>
        </div>
        <el-empty v-else description="暂无热门认证数据"></el-empty>
      </section>

      <!-- Occupational Standards Section -->
      <section class="section-block standards-section">
        <div class="hr-header white-text">
          <div class="hr-title-row">
            <div class="hr-title-main">
              <img src="@/assets/new_picture/i_tt_2.png" alt="" class="hr-icon">
              <span>职业标准</span>
            </div>
          </div>
          <div class="hr-subtitle">只为核心推荐 为您的英才计划保驾护航 没有最好 只有更好</div>
        </div>
        
        <div class="standards-grid">
          <div class="standard-item-wrapper" v-for="(std, index) in displayedStandards" :key="index" @click="openStandard(std)">
            <div class="standard-card">
              <div class="standard-card-inner">
                <div class="std-top">
                  <div class="std-ministry">国家职业技能标准</div>
                  <div class="std-code">职业编码：{{ std.id }}</div>
                  <div class="std-line"></div>
                </div>
                <div class="std-name">{{ std.name }}</div>
                <div class="std-footer">
                  <div class="std-org">中华人民共和国人力资源和社会保障部 制定</div>
                </div>
              </div>
            </div>
            <div class="standard-caption">{{ std.name }}职业技能标准</div>
          </div>
        </div>

        <div class="standards-more" v-if="hasMoreStandards" @click="showAllStandards = !showAllStandards">
          <span>{{ showAllStandards ? '收起' : '查看更多' }}</span>
          <i :class="showAllStandards ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
      </section>

      <!-- PDF Preview Dialog -->
      <el-dialog :visible.sync="pdfDialogVisible" width="80%" top="5vh" append-to-body :title="pdfDialogTitle" custom-class="pdf-dialog">
        <div class="pdf-container">
          <iframe 
            v-if="pdfUrl" 
            :src="getPdfViewerUrl(pdfUrl)" 
            width="100%" 
            height="100%" 
            style="border: none;"
          ></iframe>
          <div v-if="pdfUrl" class="pdf-fallback">
            <p>PDF预览加载中...如无法显示，请点击下载：</p>
            <a :href="pdfUrl" target="_blank" download class="download-link">下载PDF</a>
          </div>
        </div>
      </el-dialog>

      <!-- Certificate Query Result Dialog -->
      <el-dialog 
        :visible.sync="queryDialogVisible" 
        width="600px" 
        custom-class="cert-result-dialog"
        title="证书查询结果"
        append-to-body
      >
        <div class="cert-result-content" v-if="queryResult">
          <div class="student-info">
            <div class="info-item">
              <span class="label">姓名：</span>
              <span class="value">{{ queryResult.studentName }}</span>
            </div>
            <div class="info-item">
              <span class="label">证件号码：</span>
              <span class="value">{{ queryResult.idCard }}</span>
            </div>
          </div>
          
          <div class="cert-list">
            <div v-if="queryResult.certificates && queryResult.certificates.length > 0">
              <div 
                v-for="cert in queryResult.certificates" 
                :key="cert.id" 
                class="cert-item"
              >
                <div class="cert-header">
                  <div class="cert-name">{{ cert.certificateName }}</div>
                  <div class="cert-status" :class="{ 'expired': cert.status === 2 }">
                    {{ cert.status === 1 ? '生效中' : '已过期' }}
                  </div>
                </div>
                <div class="cert-body">
                  <div class="cert-row">
                    <span class="cert-label">证书编号：</span>
                    <span class="cert-value">{{ cert.certificateNo }}</span>
                  </div>
                  <div class="cert-row">
                    <span class="cert-label">颁发时间：</span>
                    <span class="cert-value">{{ cert.issueTime }}</span>
                  </div>
                  <div class="cert-row" v-if="cert.expireTime">
                    <span class="cert-label">失效时间：</span>
                    <span class="cert-value">{{ cert.expireTime }}</span>
                  </div>
                </div>
                <div class="cert-actions">
                  <el-button
                    v-if="cert.renderedFileUrl"
                    type="primary"
                    size="small"
                    plain
                    @click="viewCertPdf(cert.renderedFileUrl)"
                  >查看证书</el-button>
                  <span v-else class="cert-no-file">证书文件暂未生成</span>
                </div>
              </div>
            </div>
            <el-empty v-else description="未查询到证书信息"></el-empty>
          </div>
        </div>
        <div class="cert-result-empty" v-else>
          <el-empty description="未查询到证书信息"></el-empty>
        </div>
      </el-dialog>

      <!-- PDF预览弹窗 -->
      <el-dialog
        :title="pdfTitle"
        :visible.sync="pdfDialogVisible"
        width="90%"
        top="5vh"
        custom-class="pdf-dialog"
        :close-on-click-modal="false"
        @close="closePdfDialog"
      >
        <pdf-viewer 
          v-if="pdfDialogVisible && pdfUrl" 
          :url="pdfUrl" 
          :title="pdfTitle"
        />
      </el-dialog>

  </div>
</template>

<script>
import { addAdvertisementView, getAdvertisementList, getHomepageRecommendContents } from '@/api/courseApi'
import { getHotCertificates, getCertificateCategories, getOccupationalStandards, queryCertificates } from '@/api/certificationApi'
import PdfViewer from '@/components/PdfViewer.vue'

export default {
  name: 'CertificationPage',
  components: {
    PdfViewer
  },
  data() {
    return {
      banners: [],
      queryForm: {
        name: '',
        idCard: '',
        certNo: ''
      },
      queryResult: null,
      queryLoading: false,
      queryDialogVisible: false,
      announcements: [],
      newsLoading: false,
      activeCategory: 0,
      categories: [], // Will be populated from API
      activeHotCert: '0',
      hotCerts: [], // Will be populated from API
      standards: [], // Will be populated from API
      showAllStandards: false,
      pdfDialogVisible: false,
      pdfUrl: '',
      pdfTitle: ''
    }
  },
  watch: {
    activeHotCert: {
      handler() {
        // No action needed for hot cert change anymore
      }
    }
  },
  computed: {
    hasMoreStandards() {
      return this.standards.length > 8
    },
    displayedStandards() {
      if (this.showAllStandards) {
        return this.standards
      }
      return this.standards.slice(0, 8)
    }
  },
  mounted() {
    this.fetchHomepageAdvertisements()
    this.fetchAnnouncements()
    this.fetchData()
  },
  methods: {
    async fetchAnnouncements() {
      this.newsLoading = true
      try {
        const res = await getHomepageRecommendContents({ contentCategory: 'exam_news' })
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.announcements = res.data.map(item => ({
            id: item.id,
            title: item.contentTitle,
            date: item.createTime ? item.createTime.slice(0, 10) : '',
            category: item.contentCategoryName,
            desc: item.contentText,
            raw: item
          }))
        }
      } catch (err) {
        console.error('获取平台动态失败', err)
        this.announcements = []
      } finally {
        this.newsLoading = false
      }
    },
    goToNewsDetail(item) {
      this.$router.push({
        name: 'newsDetail',
        params: {
          id: item.id,
          newsData: item
        }
      })
    },
    goToDetail(category) {
      this.$router.push({
        name: 'certificationCategoryDetail',
        params: {
          id: category.id,
          categoryData: category
        }
      })
    },
    async fetchData() {
      this.fetchCategories()
      this.fetchHotCerts()
      this.fetchStandards()
    },
    async fetchCategories() {
      try {
        const res = await getCertificateCategories()
        if (res && res.code === 200) {
          this.categories = (res.data || []).map(item => ({
            id: item.id,
            title: item.categoryName,
            subtitle: '', // API doesn't provide subtitle
            icon: 'el-icon-medal', // Default icon
            description: item.introduction ? item.introduction.replace(/<[^>]+>/g, '') : '', // Strip HTML tags for description
            features: [], // API doesn't provide features
            image: item.coverImage || require('@/assets/new_picture/pic01.png') // Fallback image
          }))
          // If empty, keep some placeholder or handle empty state? 
          // For now, if empty, the UI might look broken, but let's assume API returns data or handle in template.
        }
      } catch (e) {
        console.error('Failed to fetch certificate categories', e)
      }
    },
    async fetchHotCerts() {
      try {
        const res = await getHotCertificates() // Fetch all hot certs
        if (res && res.code === 200) {
          this.hotCerts = (res.data || []).map(item => ({
            id: item.id,
            name: item.certName,
            tags: [item.certificationCategoryName, item.validityYears ? `有效期${item.validityYears}年` : '永久有效'].filter(Boolean),
            description: item.description,
            authority: item.authority,
            reissueStrategy: item.reissueStrategyName,
            image: item.exampleImageUrl,
            imageLoadError: false,
            certificationUnit: item.authority || '认证单位',
            certificationMethod: item.certificationMethod || '认证方式'
          }))
          // Trigger initial check (no longer needed, kept for reference if needed)
        }
      } catch (e) {
        console.error('Failed to fetch hot certificates', e)
      }
    },
    handleImageError(index) {
      if (this.hotCerts[index]) {
        this.$set(this.hotCerts[index], 'imageLoadError', true)
      }
    },
    async fetchStandards() {
      try {
        const res = await getOccupationalStandards()
        if (res && res.code === 200) {
          this.standards = (res.data || []).map(item => ({
            id: item.id,
            name: item.occupationName,
            introduction: item.introduction,
            files: item.standardFiles || []
          }))
        }
      } catch (e) {
        console.error('Failed to fetch occupational standards', e)
      }
    },
    openStandard(std) {
      if (std && std.files && std.files.length > 0) {
        const file = std.files[0]
        if (file && file.url) {
          // 使用后端代理获取PDF，避免COS跨域问题
          this.pdfUrl = `/api/frontend/proxy/pdf?url=${encodeURIComponent(file.url)}`
          this.pdfTitle = std.standardName || '职业标准文档'
          this.pdfDialogVisible = true
        } else {
          this.$message.warning('文件地址无效')
        }
      } else {
        this.$message.info('暂无相关标准文件')
      }
    },
    closePdfDialog() {
      this.pdfDialogVisible = false
      this.pdfUrl = ''
      this.pdfTitle = ''
    },
    getBannerStyle(b) {
      const bg = b && b.bg ? String(b.bg) : ''
      const image = b && b.image ? String(b.image) : ''
      if (image) {
        return {
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }
      }
      return { background: bg }
    },
    openAd(banner) {
      const b = banner && typeof banner === 'object' ? banner : { link: banner }
      const url = String(b && b.link ? b.link : '').trim()
      if (!url) return
      const id = b && b.id
      if (id != null && id !== '') {
        addAdvertisementView(id).catch(() => {})
      }
      window.open(url, '_blank', 'noopener')
    },
    async fetchHomepageAdvertisements() {
      try {
        const res = await getAdvertisementList({displayPosition: 'certification_list'})

        const list = Array.isArray(res && res.data) ? res.data : []
        const enabled = list.filter(item => Number(item && item.enableStatus) === 1 && Number(item && item.adStatus) === 1)

        // Process Carousel Ads
        const carouselAds = enabled.filter(item => String(item && item.adType) === 'carousel')
        this.banners = carouselAds.map(item => ({
          id: item && item.id,
          image: item && item.adImage,
          link: item && item.adLink,
          title: item && item.adTitle,
          raw: item
        }))
      } catch (err) {
        this.banners = []
        console.error('获取广告失败', err)
      }
    },
    async handleQuery() {
      const name = (this.queryForm.name || '').trim()
      const idCard = (this.queryForm.idCard || '').trim()
      const certNo = (this.queryForm.certNo || '').trim()
      if (!name) {
        this.$message({
          message: '请填写学员姓名',
          type: 'warning',
          center: true,
          offset: window.innerHeight / 2 - 50 // 居中显示
        })
        return
      }
      if (!idCard && !certNo) {
        this.$message({
          message: '请填写证件号码或准考证号（二选一）',
          type: 'warning',
          center: true,
          offset: window.innerHeight / 2 - 50 // 居中显示
        })
        return
      }

      this.queryLoading = true
      try {
        const params = {
          studentName: name,
          idCard: idCard || undefined,
          examNumber: certNo || undefined
        }
        const res = await queryCertificates(params)
        if (res.code === 200) {
          this.queryResult = res.data
          this.queryDialogVisible = true
        } else {
          this.$message({
            message: res.message || '查询失败',
            type: 'error',
            center: true,
            offset: window.innerHeight / 2 - 50
          })
        }
      } catch (e) {
        console.error('Certificate query failed:', e)
        this.$message({
          message: e.message || '查询失败，请稍后重试',
          type: 'error',
          center: true,
          offset: window.innerHeight / 2 - 50
        })
      } finally {
        this.queryLoading = false
      }
    },
    viewCertPdf(url) {
      if (!url) return
      window.open(url, '_blank')
    },
    getPdfViewerUrl(url) {
      if (!url) return ''
      return url
    }
  }
}
</script>

<style scoped lang="scss">
.certification-page {
  background-color: #143670;
  min-height: 100vh;
}

.hero {
  background: #fff;
}

.carousel-slide {
  height: 360px;
  background: linear-gradient(90deg, #4f46e5, #7c3aed);
  position: relative;
  cursor: pointer;
}

.overlay {
  position: absolute;
  left: 8%;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
}

.page-content {
  /* Removed constraint */
  padding: 0;
}

.section-block {
  margin-bottom: 0; /* Let each section handle its own spacing/padding */
  background: #fff;
  padding: 60px 0; /* Standard padding */
  box-shadow: none;
}

.hr-header {
  margin-bottom: 40px;
  text-align: center;
  
  .hr-title-row {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    
    .hr-title-main {
      display: flex;
      align-items: center;
      gap: 12px;
      
      span {
        font-size: 28px;
        font-weight: bold;
        color: #333;
      }
      
      .hr-icon {
        width: 32px;
        height: 32px;
      }
    }
  }
  
  .hr-subtitle {
    font-size: 14px;
    color: #666;
    letter-spacing: 1px;
  }

  &.white-text {
    .hr-title-main span {
      color: #fff;
    }
    .hr-subtitle {
      color: rgba(255,255,255,0.8);
    }
  }
}

/* Hot Certifications (New Style) */
.hot-certs-section {
  padding: 60px 0 !important;
  background: transparent;
}

.hot-cert-card {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.hot-cert-header {
  height: 120px;
  background: linear-gradient(90deg, #4f46e5 0%, #7c3aed 100%);
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  padding: 0 40px;
}

.timeline-track {
  position: absolute;
  top: 75px; /* Adjust based on dot position */
  left: 40px;
  right: 40px;
  height: 1px;
  background: rgba(255,255,255,0.3);
  z-index: 1;
}

.cert-tab-item {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  
  .tab-pill {
    padding: 6px 16px;
    border-radius: 20px;
    color: rgba(255,255,255,0.8);
    font-size: 14px;
    margin-bottom: 20px;
    transition: all 0.3s;
  }
  
  .tab-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    transition: all 0.3s;
    box-shadow: 0 0 0 4px rgba(255,255,255,0.1);
  }

  &:hover {
    .tab-pill { color: #fff; }
  }

  &.active {
    .tab-pill {
      background: #f59e0b; /* Orange/Yellow */
      color: #fff;
      font-weight: bold;
      box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);
    }
    
    .tab-dot {
      width: 14px;
      height: 14px;
      background: #f59e0b;
      box-shadow: 0 0 0 4px rgba(255,255,255,0.2);
    }
  }
}

.hot-cert-body {
  padding: 40px;
  display: flex;
  gap: 20px;
  min-height: 400px;
}

.cert-content-item {
  flex: 1;
  
  .cert-info-row {
    display: flex;
    align-items: center;
    
    .cert-unit-label {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
    
    .cert-project-name {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }
  }
}

.cert-content-left {
  .cert-info-row {
    justify-content: flex-start;
  }
}

.cert-content-center {
  .cert-info-row {
    justify-content: center;
  }
  
  .cert-desc-row {
    margin-top: 20px;
    text-align: left;
    
    .cert-desc-text {
      font-size: 14px;
      line-height: 1.8;
      color: #666;
      text-align: justify;
      
      ::v-deep p {
        margin-bottom: 10px;
        text-indent: 2em;
      }
    }
  }
}

.cert-content-right {
  flex: 0 0 300px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  
  .cert-image-wrapper {
    width: 100%;
    border: 8px solid #f0f2f5;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    
    img {
      width: 100%;
      display: block;
    }
  }
}

/* Certificate Query */
.query-section {
  background: #f0f7ff url('~@/assets/new_picture/ks_bg01.png') no-repeat center center;
  background-size: cover;
  padding: 60px 0;
}

.query-container {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(0,0,0,0.05);
  display: flex;
  overflow: hidden;
  padding: 30px;
  gap: 30px;
}

/* Left Side */
.query-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.query-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  
  .query-title {
    font-size: 18px;
    color: #4f46e5;
    font-weight: bold;
    margin: 0;
  }
  
  .query-more {
    font-size: 14px;
    color: #999;
    text-decoration: none;
    
    &:hover { color: #4f46e5; }
  }
}

.query-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
  max-height: 200px;
  overflow-y: auto;
  
  li {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px dashed #f0f0f0;
    font-size: 14px;
    color: #333;
    
    .query-dot {
      width: 4px;
      height: 4px;
      background: #ccc;
      margin-right: 10px;
      flex-shrink: 0;
    }
    
    .query-text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 20px;
    }
    
    .query-date {
      color: #999;
      font-size: 13px;
    }
  }
}

.query-tips {
  margin-top: 30px;
  background: #fff8f0;
  padding: 20px;
  border-radius: 8px;
  
  .tips-title {
    color: #e65100;
    font-weight: bold;
    margin-bottom: 10px;
    font-size: 15px;
  }
  
  .tips-content p {
    margin: 5px 0;
    font-size: 13px;
    color: #e65100;
    line-height: 1.6;
  }
}

/* Right Side */
.query-right {
  flex: 0 0 380px;
}

.form-card {
  background: #4f46e5; /* Fallback */
  background: linear-gradient(135deg, #5b7cfa 0%, #3e5bf0 100%);
  border-radius: 12px;
  padding: 6px; /* Outer border effect */
  box-shadow: 0 8px 25px rgba(62, 91, 240, 0.3);
}

.form-header {
  text-align: center;
  color: #4f46e5;
  background: #dbeafe;
  padding: 15px 0;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px 8px 0 0;
}

.custom-query-form {
  background: #dbeafe; /* Light blue background for form area */
  padding: 20px 30px;
  
  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
  
  ::v-deep .el-form-item__label {
    color: #333;
    font-weight: bold;
    line-height: 40px;
  }
  
  ::v-deep .el-input__inner {
    border-radius: 4px;
    border: 1px solid #ccc;
    height: 40px;
  }
}

.query-submit-btn {
  width: 100%;
  background: #3e2ccd;
  border: none;
  height: 44px;
  font-size: 16px;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: bold;
  letter-spacing: 2px;
  
  &:hover {
    background: #3122a3;
  }
}

.form-footer {
  background: #dbeafe;
  padding: 0 30px 30px;
  border-radius: 0 0 8px 8px;
  
  .footer-label {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }
  
  .footer-text {
    font-size: 12px;
    color: #666;
    line-height: 1.6;
  }
}

/* Certification Categories */
.categories-section {
  background: #0084ff url('~@/assets/new_picture/rz_bg02.png') no-repeat center center;
  background-size: cover;
  padding: 60px 0;
  overflow: hidden;
}

.categories-accordion {
  max-width: 1200px;
  margin: 0 auto;
  height: 500px;
  display: flex;
  background: transparent;
  padding: 0 20px;
  gap: 2px;
}

.accordion-item {
  position: relative;
  height: 100%;
  cursor: pointer;
  transition: flex 0.5s ease-in-out, width 0.5s ease-in-out;
  overflow: hidden;
  flex: 1;
  background: #333;
  
  &.active {
    flex: 3.5;
    background: #fff;
    cursor: default;
  }
}

.accordion-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 40px;
  
  .cover-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 1;
    transition: background 0.3s;
  }
  
  .cover-title {
    position: relative;
    z-index: 2;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    writing-mode: vertical-rl;
    text-orientation: upright;
  }
}

.accordion-item:hover .cover-overlay {
  background: rgba(0,0,0,0.3);
}

.accordion-item.active .accordion-cover {
  display: none;
}

.accordion-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.detail-header {
  height: 60px;
  background: #50bfff; /* Fallback */
  background: linear-gradient(to right, #29a0f6, #6dd5fa);
  display: flex;
  align-items: center;
  padding: 0 30px;
  color: #fff;
  
  .detail-title {
    font-size: 22px;
    font-weight: bold;
    margin-right: 15px;
  }
  
  .detail-subtitle {
    font-size: 16px;
    opacity: 0.9;
  }
}

.detail-body {
  flex: 1;
  display: flex;
  padding: 30px;
  gap: 30px;
  overflow: hidden;
}

.detail-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  
  .text-scroll {
    flex: 1;
    overflow-y: auto;
    font-size: 14px;
    line-height: 1.8;
    color: #666;
    text-align: justify;
    padding-right: 10px;
    
    p {
      margin-bottom: 15px;
      text-indent: 2em;
    }
  }
  
  .detail-more {
    margin-top: 20px;
    color: #29a0f6;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    
    &:hover {
      text-decoration: underline;
    }
    
    i { margin-left: 5px; }
  }
}

.detail-image {
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  border: 1px solid #eee;
  padding: 10px;
  
  img {
    max-width: 100%;
    max-height: 100%;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
}

/* Hot Certifications */
.hot-certs-section {
  padding: 40px 40px;
}

.hot-certs-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 30px;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #3E2CCD;
    border-bottom-color: #fff;
  }
}

.cert-detail {
  display: flex;
  gap: 40px;
  padding: 20px;
  
  .cert-info {
    flex: 1;
    h3 { font-size: 24px; color: #303133; margin-bottom: 15px; }
    
    .cert-tags {
      margin-bottom: 20px;
      .el-tag { margin-right: 10px; }
    }
    
    .cert-desc {
      font-size: 14px;
      color: #606266;
      line-height: 1.8;
      margin-bottom: 25px;
    }
    
    .cert-highlights {
      background: #f8faff;
      padding: 20px;
      border-radius: 4px;
      margin-bottom: 25px;
      
      .highlight-item {
        margin-bottom: 10px;
        &:last-child { margin-bottom: 0; }
        
        .label { color: #909399; width: 80px; display: inline-block; }
        .value { color: #303133; font-weight: 500; }
      }
    }
    
    .apply-btn {
      width: 150px;
      background-color: #3E2CCD;
      border-color: #3E2CCD;
    }
  }
  
  .cert-sample {
    width: 300px;
    
    .sample-box {
      border: 10px solid #f2f2f2;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      
      img {
        width: 100%;
        display: block;
      }
      
      .sample-caption {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,0.6);
        color: #fff;
        text-align: center;
        padding: 8px 0;
        font-size: 12px;
      }
    }
  }
}

/* Occupational Standards Section */
.standards-section {
  padding: 60px 0;
  position: relative;
  background: #143670;
}

.standards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.standard-item-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s;
  
  &:hover {
    transform: translateY(-5px);
  }
}

.standard-card {
  width: 100%;
  padding-bottom: 141.4%; /* A4 Aspect Ratio 1:1.414 */
  position: relative;
  background: #fff;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  border-radius: 2px;
}

.standard-card-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}

.std-top {
  .std-ministry {
    font-size: 15px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
    font-family: "SimSun", serif;
  }
  .std-code {
    font-size: 12px;
    color: #999;
    transform: scale(0.9);
  }
  .std-line {
    width: 80%;
    height: 1px;
    background: #e0e0e0;
    margin: 15px auto;
  }
}

.std-name {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 2px;
}

.std-footer {
  .std-org {
    font-size: 12px;
    color: #666;
    transform: scale(0.85);
    white-space: nowrap;
  }
}

.standard-caption {
  margin-top: 15px;
  color: rgba(255,255,255,0.7);
  font-size: 13px;
  text-align: center;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.standards-more {
  text-align: center;
  margin-top: 50px;
  color: rgba(255,255,255,0.6);
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  
  &:hover {
    color: #fff;
  }
}
  .cert-result-content {
    padding: 20px;
    
    .student-info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid #eee;
      
      .info-item {
        font-size: 16px;
        color: #333;
        
        .label {
          color: #666;
        }
        
        .value {
          font-weight: bold;
        }
      }
    }
    
    .cert-list {
      .cert-item {
        background: #f9f9f9;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 15px;
        border: 1px solid #eee;
        
        .cert-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          
          .cert-name {
            font-size: 18px;
            font-weight: bold;
            color: #333;
          }
          
          .cert-status {
            padding: 2px 8px;
            border-radius: 4px;
            font-size: 12px;
            background: #e1f3d8;
            color: #67c23a;
            
            &.expired {
              background: #fde2e2;
              color: #f56c6c;
            }
          }
        }
        
        .cert-body {
          .cert-row {
            margin-bottom: 5px;
            font-size: 14px;
            
            .cert-label {
              color: #666;
            }
            
            .cert-value {
              color: #333;
            }
          }
        }

        .cert-actions {
          margin-top: 12px;
          text-align: right;

          .cert-no-file {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
  }

    .cert-image-wrapper {
    position: relative;
    min-height: 200px;
    background: #f9f9f9;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .preview-image {
      max-width: 100%;
      max-height: 400px;
    }
    
    img {
      max-width: 100%;
      max-height: 400px;
      object-fit: contain;
    }
    
    iframe {
      border: none;
    }
  }

  /* PDF Dialog Styles */
  :deep(.pdf-dialog) {
    .el-dialog__body {
      padding: 0;
      height: 80vh;
    }
  }
  
  .pdf-container {
    width: 100%;
    height: 100%;
    min-height: 75vh;
    background: #525659;
    position: relative;
  }

  .pdf-fallback {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #fff;
    background: rgba(0,0,0,0.7);
    padding: 30px;
    border-radius: 8px;
    
    p {
      margin-bottom: 15px;
      font-size: 14px;
    }
    
    .download-link {
      display: inline-block;
      padding: 10px 20px;
      background: #409eff;
      color: #fff;
      text-decoration: none;
      border-radius: 4px;
      font-size: 14px;
      
      &:hover {
        background: #66b1ff;
      }
    }
  }
</style>